import {
  Component, Input, Output, EventEmitter, ViewChild, DoCheck
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';

import { ScorecardDropdownComponent } from 'shared/dropdown/scorecard-dropdown/scorecard-dropdown.component';
import { MyProductsSearchComponent } from '../my-products-search/my-products-search.component';
import { PermissionsService } from 'shared/permissions/permissions.service';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';
import { CommentIconComponent } from 'shared/alerts/comment-icon/comment-icon.component';


@Component({
  moduleId: module.id,
  selector: 'my-products-header',
  templateUrl: 'my-products-header.component.html',
  styleUrls: ['my-products-header.component.scss'],
})
export class MyProductsHeaderComponent implements DoCheck {
  searchModelFiltersForAdvancedSearch: Array<ActiveFilterModel>;
  // hack of filters (objects array) ignore in ngOnChanges
  // https://github.com/angular/angular/issues/6458
  prevFilters: any[];

  @Input() headerColor: string = 'darkred';
  @Input() filters: Array<ActiveFilterModel>;
  @Input() showListManagerBtn: boolean = false;
  @Input() isListManagerShown: boolean = false;
  @Input() hasAdvancedSearch: boolean = false;
  @Input() searchValue: string;
  @Input() ghostValue: string;
  @Input() actions: any = [];
  @Input() pagesMenuData: any;
  @Input() currentPageData: any;
  @Input() statuses: any;
  @Input() statusModel: any;
  @Input() searchModel: any;
  @Input() searchService: any;
  @Input() advancedSearchStatus: string;
  @Input() searchResultsColumns: any;

  // scorecards
  @Input() showScorecards: boolean = true;
  @Input() scorecardList: Array<any> = [];
  @Input() selectedScorecardId: any;

  // pagination
  @Input() totalRecords: any;
  @Input() currentPage: any;
  @Input() itemsPerPage: any;

  // tabs
  @Input() isTabsClickableWhenActive: boolean = false;
  @Input() leftTabTitle: string;
  @Input() rightTabTitle: string;
  @Input() isLeftTabActive: boolean = false;
  @Input() isLeftTabClickable: boolean = true;
  @Input() isRightTabClickable: boolean = true;
  @Input() isRightTabActive: boolean = false;

  @Input() fileName: string; // for import/export review file

  @Output() filterRemove: EventEmitter<any> = new EventEmitter();
  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchRun: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchCancel: EventEmitter<any> = new EventEmitter();
  @Output() searchValueChanged: EventEmitter<any> = new EventEmitter();

  @Output() listManagerClick: EventEmitter<any> = new EventEmitter();
  @Output() removeMenuItem: EventEmitter<any> = new EventEmitter();
  @Output() statusSelected: EventEmitter<any> = new EventEmitter();

  @Output() pageActionSelect: EventEmitter<any> = new EventEmitter();
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  @Output() itemsPerPageChange: EventEmitter<any> = new EventEmitter();
  @Output() scorecardChanged: EventEmitter<any> = new EventEmitter();
  @Output() leftTabClick: EventEmitter<any> = new EventEmitter();
  @Output() rightTabClick: EventEmitter<any> = new EventEmitter();

  @ViewChild(MyProductsSearchComponent, {static: false})
  searchComponent: MyProductsSearchComponent | void;

  @ViewChild(ScorecardDropdownComponent, {static: false})
  scorecardDropdown: ScorecardDropdownComponent | void;

  @ViewChild(CommentIconComponent, {static: false})
  commentIcon: CommentIconComponent | void;

  constructor(
    protected router: Router,
    protected permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get searchInputValue(): string {
    return this.searchComponent && this.searchComponent.searchInputValue;
  }

  get advancedSearchComponent(): any {
    return this.searchComponent && this.searchComponent.advancedSearch;
  }

  get scorecardForStatus(): any {
    if (this.showScorecards && this.selectedScorecardId && this.selectedScorecardId !== 'off') {
      const selecredScorecard = _.find(this.scorecardList, {_id: this.selectedScorecardId});
      return selecredScorecard ? selecredScorecard.name : null;
    }
    return null;
  }

  get leftAllowClick(): boolean {
    return this.isLeftTabClickable;
  }

  get rightAllowClick(): boolean {
    return this.isRightTabClickable;
  }

  get showStatusesDropdown(): boolean {
    return this.currentPageData.name !== 'published' &&
           this.currentPageData.name !== 'view-export';
  }

  get allStatusesTitle(): string {
    if (this.currentPageData.name === 'published') {
      return 'All Published';
    } else if (this.currentPageData.name === 'working') {
      return 'All statuses';
    } else {
      return this.fileName;
    }
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngDoCheck() {
    if (!_.isEqual(this.filters, this.prevFilters)) {
      this.prevFilters = _.cloneDeep(this.filters);

      this.searchModelFiltersForAdvancedSearch = _.filter(this.filters, (filter: ActiveFilterModel) => {
        return _.get(filter, '_id') !== 'scorecardId';
      });
    }
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

   public resetSearchValue(value: string) {
     if (this.searchComponent) {
       this.searchComponent.resetSearchValue(value);
     }
   }

   public selectScorecardById(_id: string) {
     if (!this.scorecardDropdown) {
         return;
     }
     this.scorecardDropdown.selectScorecardById(_id);
   }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onFilterRemove(event: any) {
    // after filtering scorecard filter we get different filters array
    // thus after removing filter in this array we need to remove it from original array also
    _.remove(this.filters, event);
    this.filterRemove.emit(event);
  }

  onClearSearchClick() {
    this.clearSearchClick.emit();
  }

  onAdvancedSearchClick() {
    this.advancedSearchClick.emit();
  }

  onPageActionSelect(event: any) {
    this.pageActionSelect.emit(event);
  }

  onRemoveMenuItem(event: any) {
    this.removeMenuItem.emit();
  }

  onStatusSelected(event: any) {
    this.statusSelected.emit(event);
  }

  onLeftTabClick() {
    this.leftTabClick.emit();
  }

  onRightTabClick() {
    this.rightTabClick.emit();
  }

  onScorecardChange(event: any) {
    this.scorecardChanged.emit(event);
  }

  onActionSelect(event: any) {
    this.pageActionSelect.emit(event);
  }

  onListManagerClick() {
    this.listManagerClick.emit();
  }

  onAdvancedSearchRun() {
    this.advancedSearchRun.emit();
  }

  onAdvancedSearchCancel() {
    this.advancedSearchCancel.emit();
  }

  onSearchValueChanged(event: any) {
    this.searchValueChanged.emit(event);
  }

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }

  onItemsPerPageChange(event: any) {
    this.itemsPerPageChange.emit(event);
  }

  onShowNotifications() {
    if (this.commentIcon) {
      this.commentIcon.showAndHide();
    }
  }
}
